// src/utils/powerCal.ts

/** Apply a scalar calibration alpha to a per-sample physics waveform. */
export function applyAlphaOnce(samplesW: number[], alpha: number): number[] {
  if (!Number.isFinite(alpha) || alpha <= 0) return samplesW; // defensive: no double or nonsense
  // IMPORTANT: Do not apply anywhere else in the pipeline; this is the only per-sample scaling.
  return samplesW.map((v) => v * alpha);
}

/** Fast in-place 95th percentile (does not mutate original). */
export function p95(values: number[]): number {
  if (!values.length) return 0;
  const arr = [...values].sort((a, b) => a - b);
  const idx = Math.min(arr.length - 1, Math.floor(0.95 * arr.length));
  return arr[idx];
}

/** Round up to nice chart domain value */
export function roundUpToNice(value: number, step: number = 50): number {
  return Math.max(step * 2, Math.ceil(value / step) * step);
}
